import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { HistoryFindInterface } from '@zaoblako/shared/common/dtos/history/history-find.dto';
import { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';
import { ButtonShowAndHideComponent } from '@zaoblako/web/shared/components/button-show-and-hide/button-show-and-hide.component';
import { UserAvatarComponent } from '@zaoblako/web/shared/components/user-avatar/user-avatar.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { OrderByPipe } from '@zaoblako/web/shared/pipes/order-by.pipe';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TimelineModule } from 'primeng/timeline';

@Component({
  standalone: true,
  selector: 'crm-directory-common-history[apiService]',
  templateUrl: './directory-common-history.component.html',
  imports: [
    CommonModule,
    CardModule,
    ButtonShowAndHideComponent,
    TimelineModule,
    OrderByPipe,
    UserAvatarComponent,
    ProgressSpinnerModule,
    SpinnerComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DirectoryCommonHistoryComponent implements OnInit {
  @Input() private readonly apiService: DirectoryHistoryServiceInterface;
  @Input() private readonly entityId: string | number;
  @Input() private readonly entityName: string;

  public historyItems: HistoryFindInterface[] = [];
  public showHistory: boolean = false;
  public paginationLoading: boolean = false;
  public loading: boolean = false;
  public count: number;

  private queryParams: PaginationQueryInterface = {
    limit: 100,
    offset: 0
  };

  public constructor(private readonly cdRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    if (!this.entityId) {
      return;
    }

    if (this.apiService && localStorage.getItem(`${this.entityName}.showHistory`)) {
      this.showHistory = JSON.parse(localStorage.getItem(`${this.entityName}.showHistory`));
      this.showHistory && this.loadHistory();
    }
  }

  public toHistory(history: any): HistoryFindInterface {
    return history as HistoryFindInterface;
  }

  private loadHistory({ concat } = { concat: false }) {
    if (!concat) {
      this.loading = true;
    }

    this.apiService.getHistoryForOne(this.entityId, this.queryParams).subscribe({
      next: (data) => {
        this.queryParams.limit = data.limit;
        this.queryParams.offset = data.offset;
        this.count = data.count;
        this.historyItems = concat ? this.historyItems.concat(data.items) : data.items;

        this.loading = false;
        this.paginationLoading = false;
        this.cdRef.markForCheck();
      }
    });
  }

  public onScrollEndHistory(target: HTMLElement) {
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight) {
      if (this.historyItems.length < this.count && !this.loading && !this.paginationLoading) {
        this.paginationLoading = true;
        this.queryParams.offset += this.queryParams.limit;
        this.loadHistory({ concat: true });
      }
    }
  }

  public showHistoryChange(showHistory: boolean) {
    this.showHistory = showHistory;
    if (this.showHistory) this.loadHistory();
    localStorage.setItem(`${this.entityName}.showHistory`, JSON.stringify(this.showHistory));
  }
}
